/**
 * Shared HG customization preview renderer (720px reference canvas).
 * Matches PDP customizer (hadiyah-pdp-customizer.js) overlay layout + fonts.
 */
(function (global) {
  if (global.HgCustomizationRender) return;

  var CANVAS_REF = 720;
  var GLITTER_GRAIN_URL = (function () {
    try {
      if (typeof window !== 'undefined' && window.HG_GLITTER_GRAIN) return window.HG_GLITTER_GRAIN;
      var host = document.querySelector('[data-glitter-grain]');
      if (host && host.getAttribute('data-glitter-grain')) return host.getAttribute('data-glitter-grain');
    } catch (e) {}
    return '';
  })();

  var GLITTER_FILLS = {
    'gold-glitter': {
      css: 'linear-gradient(145deg,#ffd700 0%,#f0c419 18%,#e6b422 38%,#d4af37 58%,#b8860b 78%,#8b6914 100%)',
    },
    'rose-gold-glitter': {
      css: 'linear-gradient(145deg,#e8b8a8 0%,#d4927e 30%,#c07868 55%,#b76e79 78%,#8b4a52 100%)',
    },
    'silver-glitter': {
      css: 'linear-gradient(145deg,#e8ecef 0%,#c5ccd3 30%,#a8b0b8 55%,#8a939c 78%,#5a636c 100%)',
    },
    'champagne-glitter': {
      css: 'linear-gradient(145deg,#e8d4a8 0%,#d0b878 30%,#b89a58 55%,#a89050 78%,#7a6430 100%)',
    },
    'copper-glitter': {
      css: 'linear-gradient(145deg,#e8a868 0%,#d89050 30%,#c87838 55%,#a05a28 78%,#6e3a12 100%)',
    },
    'black-glitter': {
      css: 'linear-gradient(145deg,#4a4a4a 0%,#2e2e2e 35%,#1a1a1a 60%,#0e0e0e 100%)',
    },
    'holographic-glitter': {
      css: 'linear-gradient(145deg,#e070c8 0%,#5bc4d4 25%,#8b7ec8 45%,#d4c040 65%,#4caf70 85%,#5a9fd4 100%)',
    },
    'pearl-glitter': {
      css: 'linear-gradient(145deg,#f5f0e8 0%,#ebe4d8 35%,#d4cbb8 65%,#b8ad98 100%)',
    },
  };

  function findGlitterFill(id) {
    return GLITTER_FILLS[String(id || '').trim()] || null;
  }

  function zoneGlitterFill(z) {
    if (!z || z.fillType !== 'glitter') return null;
    return findGlitterFill(z.glitterId);
  }

  function glitterTextStyleCss(glitter) {
    if (!glitter) return '';
    var css = '--hg-glitter-fill:' + glitter.css + ';';
    if (GLITTER_GRAIN_URL) {
      css += '--hg-glitter-grain:url("' + String(GLITTER_GRAIN_URL).replace(/"/g, '%22') + '");';
    }
    return css;
  }

  function zoneFillStyleCss(z) {
    var glitter = zoneGlitterFill(z);
    if (glitter) return glitterTextStyleCss(glitter);
    return z.color ? 'color:' + escapeCss(z.color) + ';' : 'color:#1b2430;';
  }

  function ensureGlitterStyles() {
    var id = 'hg-customization-render-glitter';
    if (document.getElementById(id)) return;
    var grain = GLITTER_GRAIN_URL
      ? 'url("' + String(GLITTER_GRAIN_URL).replace(/"/g, '\\"') + '")'
      : 'url("glitter-grain.svg")';
    var style = document.createElement('style');
    style.id = id;
    style.textContent =
      '.hg-customization-preview__zone.is-glitter-fill .hg-customization-preview__zone-text{' +
      'background-image:' +
      grain +
      ',var(--hg-glitter-fill,linear-gradient(145deg,#ffd700,#8b6914));' +
      'background-blend-mode:normal,normal;' +
      'background-size:16px 16px,100% 100%;' +
      'background-repeat:repeat,no-repeat;' +
      '-webkit-background-clip:text;' +
      'background-clip:text;' +
      'color:#b8860b!important;' +
      '-webkit-text-fill-color:transparent;' +
      'text-shadow:none!important;' +
      '}';
    document.head.appendChild(style);
  }

  function normalizePreviewUrl(raw) {
    if (!raw || typeof raw !== 'string') return '';
    var url = raw.trim();
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.indexOf('/') === 0) return global.location.origin + url;
    return url;
  }

  function isPreviewPageUrl(raw) {
    if (!raw) return false;
    return /\/pages\//i.test(String(raw)) || /customization-preview/i.test(String(raw));
  }

  function isLoadablePreviewImage(raw) {
    var url = normalizePreviewUrl(raw);
    if (!url || isPreviewPageUrl(url)) return false;
    if (/^data:image\//i.test(url)) return true;
    if (/cdn\.shopify\.com|\/cdn\/shop\/|\/files\/|staticmeow|customeow|custom-previews|\/api\/preview-image/i.test(url)) return true;
    if (/\.(png|jpe?g|webp|gif|svg|avif)(\?|$)/i.test(url)) return true;
    return /^https?:\/\//i.test(url);
  }

  function parseZones(raw) {
    if (!raw) return [];
    try {
      var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function escapeCss(str) {
    return String(str || '').replace(/["\\]/g, '\\$&');
  }

  function ensureFonts(zones) {
    var families = [];
    (zones || []).forEach(function (z) {
      var fam = String((z && z.fontFamily) || '').trim();
      if (!fam || fam.indexOf('system') !== -1) return;
      var key = fam.replace(/['"]/g, '').split(',')[0].trim();
      if (key && families.indexOf(key) === -1) families.push(key);
    });
    if (!families.length) return;

    var id = 'hg-customization-render-fonts';
    var href =
      'https://fonts.googleapis.com/css2?family=' +
      families
        .map(function (f) {
          return encodeURIComponent(f).replace(/%20/g, '+') + ':wght@400;600;700';
        })
        .join('&family=') +
      '&display=swap';

    var existing = document.getElementById(id);
    if (existing) {
      if (existing.href !== href) existing.href = href;
      return;
    }

    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function zoneInlineStyle(z) {
    var align = z.align || 'center';
    var justify = align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center';
    var opacity = z.opacity == null ? 100 : Number(z.opacity);

    return (
      'left:' +
      (Number(z.x) || 0) +
      '%;top:' +
      (Number(z.y) || 0) +
      '%;width:' +
      (Number(z.w) || 0) +
      '%;height:' +
      (Number(z.h) || 0) +
      '%;transform:rotate(' +
      (Number(z.rotation) || 0) +
      'deg);opacity:' +
      opacity / 100 +
      ';' +
      (z.fontFamily ? 'font-family:' + escapeCss(z.fontFamily) + ';' : '') +
      zoneFillStyleCss(z) +
      'font-size:' +
      (Number(z.fontSize) || 32) +
      'px;' +
      (z.bold ? 'font-weight:700;' : 'font-weight:400;') +
      (z.italic ? 'font-style:italic;' : 'font-style:normal;') +
      'text-align:' +
      escapeCss(align) +
      ';justify-content:' +
      justify +
      ';'
    );
  }

  function scalePreviewOverlays(stage, overlays) {
    if (!stage || !overlays) return;
    var w = stage.clientWidth || CANVAS_REF;
    var scale = w / CANVAS_REF;
    overlays.style.left = '0';
    overlays.style.top = '0';
    overlays.style.width = CANVAS_REF + 'px';
    overlays.style.height = CANVAS_REF + 'px';
    overlays.style.transformOrigin = '0 0';
    overlays.style.transform = 'scale(' + scale + ')';
  }

  function mountPreviewStage(container, payload, options) {
    options = options || {};
    if (!container) return null;

    var imageUrl = normalizePreviewUrl(payload && payload.image);
    if (!isLoadablePreviewImage(imageUrl)) {
      imageUrl = '';
    }
    var zones = parseZones(payload && payload.zones);
    ensureFonts(zones);
    ensureGlitterStyles();
    container.replaceChildren();

    if (!imageUrl && !zones.length) return null;

    var stage = document.createElement('div');
    stage.className = 'hg-customization-preview__stage';
    stage.style.cssText =
      'position:relative;width:100%;max-width:' +
      (options.maxWidth || 480) +
      'px;margin:0 auto;aspect-ratio:1;background:#fff;';

    var img = null;
    if (imageUrl) {
      img = document.createElement('img');
      img.className = 'hg-customization-preview__image';
      img.alt = options.alt || 'Customization preview';
      img.decoding = 'async';
      img.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;display:block;';
      img.src = imageUrl;
      stage.appendChild(img);
    }

    var overlays = document.createElement('div');
    overlays.className = 'hg-customization-preview__overlays';
    overlays.style.cssText =
      'position:absolute;left:0;top:0;width:' +
      CANVAS_REF +
      'px;height:' +
      CANVAS_REF +
      'px;transform-origin:0 0;pointer-events:none;';

    zones.forEach(function (z) {
      if (!z || !z.text) return;
      var zone = document.createElement('div');
      zone.className =
        'hg-customization-preview__zone' +
        (zoneGlitterFill(z) ? ' is-glitter-fill' : '');
      zone.style.cssText =
        'position:absolute;display:flex;align-items:center;overflow:hidden;box-sizing:border-box;line-height:1.15;white-space:nowrap;word-break:normal;' +
        zoneInlineStyle(z);
      var text = document.createElement('span');
      text.className = 'hg-customization-preview__zone-text';
      text.textContent = z.text;
      zone.appendChild(text);
      overlays.appendChild(zone);
    });

    stage.appendChild(overlays);
    container.appendChild(stage);

    function fitMountedZones() {
      overlays.querySelectorAll('.hg-customization-preview__zone').forEach(function (zoneEl) {
        var textEl = zoneEl.querySelector('.hg-customization-preview__zone-text');
        if (!textEl) return;
        var maxFont =
          parseFloat(zoneEl.style.fontSize) ||
          parseFloat(window.getComputedStyle(textEl).fontSize) ||
          32;
        var minFont = Math.max(6, maxFont * 0.35);
        var maxW = zoneEl.clientWidth;
        var maxH = zoneEl.clientHeight;
        if (maxW <= 2 || maxH <= 2) return;
        textEl.style.display = 'block';
        textEl.style.width = '100%';
        textEl.style.maxWidth = '100%';
        textEl.style.lineHeight = '1.15';
        textEl.style.overflow = 'hidden';
        textEl.style.whiteSpace = 'nowrap';
        function fittedSize(tooLarge) {
          var low = 0;
          var high = Math.min(360, Math.max(0, Math.ceil((maxFont - minFont) / 0.5)));
          textEl.style.fontSize = maxFont + 'px';
          if (!tooLarge()) return maxFont;
          while (low < high) {
            var middle = Math.floor((low + high) / 2);
            textEl.style.fontSize = maxFont - middle * 0.5 + 'px';
            if (tooLarge()) low = middle + 1;
            else high = middle;
          }
          return maxFont - low * 0.5;
        }
        textEl.style.fontSize =
          fittedSize(function () {
            return textEl.scrollWidth > maxW + 1 || textEl.scrollHeight > maxH + 0.5;
          }) + 'px';
        if (textEl.scrollWidth > maxW + 1 || textEl.scrollHeight > maxH + 0.5) {
          textEl.style.whiteSpace = 'normal';
          textEl.style.overflowWrap = 'normal';
          textEl.style.fontSize =
            fittedSize(function () {
              return textEl.scrollHeight > maxH + 0.5;
            }) + 'px';
        }
      });
    }

    function resync() {
      scalePreviewOverlays(stage, overlays);
      fitMountedZones();
    }

    stage.__hgResync = resync;
    if (img) {
      img.addEventListener('load', resync);
      if (img.complete) resync();
    }
    global.addEventListener('resize', resync);

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        resync();
      });
      resizeObserver.observe(stage);
      stage.__hgResizeObserver = resizeObserver;
    }

    requestAnimationFrame(resync);
    setTimeout(resync, 120);
    setTimeout(resync, 350);

    return { stage: stage, img: img, overlays: overlays, resync: resync };
  }

  function resyncAllStages(root) {
    (root || document).querySelectorAll('.hg-customization-preview__stage').forEach(function (stage) {
      if (typeof stage.__hgResync === 'function') stage.__hgResync();
    });
  }

  function buildPayloadFromProperties(props, fallbackImage) {
    props = props || {};
    var image = normalizePreviewUrl(props._hg_preview_image || props['preview.image'] || fallbackImage || '');
    if (!isLoadablePreviewImage(image)) image = '';
    var zones = parseZones(props._hg_preview_zones);
    return { image: image, zones: zones };
  }

  global.HgCustomizationRender = {
    CANVAS_REF: CANVAS_REF,
    normalizePreviewUrl: normalizePreviewUrl,
    parseZones: parseZones,
    ensureFonts: ensureFonts,
    mountPreviewStage: mountPreviewStage,
    buildPayloadFromProperties: buildPayloadFromProperties,
    scalePreviewOverlays: scalePreviewOverlays,
    resyncAllStages: resyncAllStages,
  };
})(typeof window !== 'undefined' ? window : globalThis);
